// Vuex records module main file
import actions from './actions';
import mutations from './mutations';
import ivrBasicMessages from './ivrBasicMessages';
import agents from './agents';
import agentsGroups from './agentsGroups';
import holidays from './holidays';
import alternativeMenu from './alternativeMenu';
import mainMenu from './mainMenu';

const INITIAL_STATE = {
  details: {
    record: {},
    total: 0,
  },
};

const getters = {
  details: state => state.details.record,
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  namespaced: true,
  state: INITIAL_STATE,
  modules: {
    ivrBasicMessages,
    agents,
    agentsGroups,
    holidays,
    alternativeMenu,
    mainMenu,
  },
  mutations,
  actions,
  getters,
};

export default Module;
